// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_overlay.styl
// module id = 106
// module chunks = 0